import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreateCodeMutation } from "@modules/codes/services/mutations";
import { CodeFormValues, codeSchema } from "@modules/codes/validations";
import { listCodesQueryKey } from "@modules/codes/services/queries/listCodes/query";

export function useCreateCodeModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<CodeFormValues>({
    resolver: zodResolver(codeSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateCodeMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listCodesQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("limited_code_admin.success.create"),
      });

      onComplete?.();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
